import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function XpBadge() {
  const [xp, setXp] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/xp/me").then((r) => alive && setXp(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 45000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!xp) return null;

  return (
    <Link to="/dashboard" data-testid="xp-badge" className="hidden sm:flex items-center gap-2 px-2.5 py-1 rounded-md bg-white/5 border border-white/10 hover:border-white/25 transition-colors">
      <div className="flex flex-col">
        <span className="text-[10px] font-black uppercase tracking-wider leading-none" style={{ color: xp.rank_color }} data-testid="xp-rank">{xp.rank}</span>
        <div className="mt-1 h-1 w-16 rounded-full bg-white/10 overflow-hidden">
          <div className="h-full rounded-full" style={{ width: `${xp.progress_pct}%`, backgroundColor: xp.rank_color }} />
        </div>
      </div>
      <span className="font-num text-xs font-black text-white/80" data-testid="xp-value">{xp.xp}</span>
    </Link>
  );
}
